import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/android.svg'
import _imports_1 from '@/assets/images/ios.svg'
import _imports_2 from '@/assets/images/warning.svg'


const _withScopeId = n => (_pushScopeId("data-v-a57aab28"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Payment method", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 3 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Campaign CPM", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"opacity":"0.7"} }, "This is your CPM for this campaign", -1))
const _hoisted_8 = { class: "p-d-flex" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Payout Cap", -1))
const _hoisted_11 = { style: {"opacity":"0.7"} }
const _hoisted_12 = { class: "p-d-flex" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "min-budget-error p-mt-2" }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Campaign CPC", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"opacity":"0.7"} }, "This is your CPC for this campaign", -1))
const _hoisted_18 = { class: "p-d-flex" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 5 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Campaign CPI", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"opacity":"0.7"} }, "This is your CPI for this campaign", -1))
const _hoisted_23 = { class: "p-d-flex" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img"
  }),
  /*#__PURE__*/_createTextVNode("Android Cpi ")
], -1))
const _hoisted_25 = {
  class: "p-inputgroup p-mt-3",
  style: {"max-width":"320px"}
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { style: {"margin-left":"50px"} }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img"
  }),
  /*#__PURE__*/_createTextVNode("iOS CPI ")
], -1))
const _hoisted_29 = {
  class: "p-inputgroup p-mt-3",
  style: {"max-width":"320px"}
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createTextVNode(" Your rate cannot be lower than the minimum for this type of campaign ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-mt-6" }, "Campaign Budget", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Your budget", -1))
const _hoisted_34 = {
  class: "p-inputgroup p-mt-3",
  style: {"max-width":"320px"}
}
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "min-budget-error"
}
const _hoisted_37 = {
  key: 1,
  class: "min-budget-error"
}
const _hoisted_38 = {
  key: 2,
  class: "min-budget-error"
}
const _hoisted_39 = { class: "field-checkbox p-mt-5" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-ml-3",
  for: "binary"
}, "I want to verify my Payment Information", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_AskHint = _resolveComponent("AskHint")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SecretTip = _resolveComponent("SecretTip")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    ($props.paymentMethod === 'CPI')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " A CPI (Cost Per Install) deal focuses on the number of installs a game or app gets through a specific tracking link. When you opt for this pricing model, you essentially pay for the number of installs your game or app earns. This is good for you as you pay strictly based on the installs you want. However, CPI can be less attractive to many creators as they are often paid less than the actual number of downloads they influenced. "))
      : _createCommentVNode("", true),
    ($props.paymentMethod === 'CPC')
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " CPC (Cost per Click) advertising is a model in which advertisers are charged only when the actual click on the ad has been made. CPC represents the amount you are willing to pay for a single click. With CPC you only pay when the user is interested enough to know more about the product. You may see a high click through rate but that does not guarantee conversions. You need to make sure the landing page is attractive enough to generate conversions after clicks. "))
      : _createCommentVNode("", true),
    ($props.paymentMethod === 'CPM')
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " CPM (cost-per-mille) values the number of views sponsored videos get, with a cost per 1000 views. These views are tracked and paid out for the first 30 days that the video is live - all future views will not cost you but will still bring exposure to your ad. CPM enables you to focus on awareness and engagement. This payment method is very attractive to creators as they can better gauge the amount that they are likely to earn. Do consider that views do not equal conversions; also that one larger creators can use up a lot of budget, so make sure to set that max payout cap. "))
      : _createCommentVNode("", true),
    ($props.paymentMethod === 'CPM')
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_InputNumber, {
              onInput: $setup.emitNewValue,
              "input-style": "background: #FFFFFF;bcountingProgressox-shadow:\n              3px 4px 15px rgba(0, 0, 0, 0.1);font-weight: bold;font-size: 24px;\n                        border-bottom-left-radius: 10px;border-top-left-radius: 10px;padding-left:25px;\n                        line-height: 29px;color: #162020;",
              modelValue: $setup.cpmValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.cpmValue) = $event)),
              mode: "currency",
              min: 0.1,
              currency: $setup.selectedCurrency,
              class: _normalizeClass([ $setup.cpiIos < $setup.minIos ? 'p-invalid' : '' ])
            }, null, 8, ["onInput", "modelValue", "min", "currency", "class"]),
            _withDirectives(_createElementVNode("select", {
              class: "multi-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedCurrency) = $event)),
              disabled: $props.campaign?.budget.currency,
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.emitNewValue && $setup.emitNewValue(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currency, (cur, index) => {
                return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(cur), 1))
              }), 128))
            ], 40, _hoisted_9), [
              [_vModelSelect, $setup.selectedCurrency]
            ])
          ]),
          _hoisted_10,
          _createElementVNode("h5", _hoisted_11, [
            _createTextVNode(" This is your max payout cap for each creator on this campaign "),
            _withDirectives(_createVNode(_component_AskHint, { class: "p-ml-1" }, null, 512), [
              [
                _directive_tooltip,
                'This is the max payout that a single creator can gain from this campaign.' +
         ' E.g. if you chose a cap at $3000 and a CPM rate of $20 then after the creator has gained 150,000 views they' +
          ' would no longer earn from their views generated within the 30 days as they have hit the $3000 cap.' +
           ' (Keep in mind that lower caps may discourage larger creators who are more likely to gain more views' +
            ' within the 30 days).’',
                void 0,
                { right: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_InputNumber, {
              onInput: $setup.emitNewValue,
              "input-style": "background: #FFFFFF;bcountingProgressox-shadow:\n              3px 4px 15px rgba(0, 0, 0, 0.1);font-weight: bold;font-size: 24px;\n                        border-bottom-left-radius: 10px;border-top-left-radius: 10px;padding-left:25px;\n                        line-height: 29px;color: #162020;",
              modelValue: $setup.cpmPayoutCap,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.cpmPayoutCap) = $event)),
              mode: "currency",
              min: 0.1,
              currency: $setup.selectedCurrency,
              class: _normalizeClass([ $setup.cpiIos < $setup.minIos ? 'p-invalid' : '' ])
            }, null, 8, ["onInput", "modelValue", "min", "currency", "class"]),
            _withDirectives(_createElementVNode("select", {
              class: "multi-select",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.selectedCurrency) = $event)),
              disabled: $props.campaign?.budget.currency,
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.emitNewValue && $setup.emitNewValue(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currency, (cur, index) => {
                return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(cur), 1))
              }), 128))
            ], 40, _hoisted_13), [
              [_vModelSelect, $setup.selectedCurrency]
            ])
          ]),
          _withDirectives(_createElementVNode("span", _hoisted_14, " Please ensure the max payout cap is higher than your CPM rate for this campaign ", 512), [
            [_vShow, $setup.cpmPayoutCap <= $setup.cpmValue]
          ])
        ]))
      : _createCommentVNode("", true),
    ($props.paymentMethod === 'CPC')
      ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_InputNumber, {
              onInput: $setup.emitNewValue,
              "input-style": "background: #FFFFFF;bcountingProgressox-shadow:\n              3px 4px 15px rgba(0, 0, 0, 0.1);font-weight: bold;font-size: 24px;\n                        border-bottom-left-radius: 10px;border-top-left-radius: 10px;padding-left:25px;\n                        line-height: 29px;color: #162020;",
              modelValue: $setup.cpcValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.cpcValue) = $event)),
              mode: "currency",
              min: 0.1,
              currency: $setup.selectedCurrency,
              class: _normalizeClass([ $setup.cpiIos < $setup.minIos ? 'p-invalid' : '' ])
            }, null, 8, ["onInput", "modelValue", "min", "currency", "class"]),
            _withDirectives(_createElementVNode("select", {
              class: "multi-select",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.selectedCurrency) = $event)),
              disabled: $props.campaign?.budget.currency,
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.emitNewValue && $setup.emitNewValue(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currency, (cur, index) => {
                return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(cur), 1))
              }), 128))
            ], 40, _hoisted_19), [
              [_vModelSelect, $setup.selectedCurrency]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($props.paymentMethod === 'CPI')
      ? (_openBlock(), _createElementBlock("section", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", null, [
              _hoisted_24,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_InputNumber, {
                    onInput: $setup.emitNewValue,
                    "input-style": "background: #FFFFFF;bcountingProgressox-shadow:\n              3px 4px 15px rgba(0, 0, 0, 0.1);font-weight: bold;font-size: 24px;\n                        border-bottom-left-radius: 10px;border-top-left-radius: 10px;padding-left:25px;\n                        line-height: 29px;color: #162020;",
                    modelValue: $setup.cpiAndroid,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.cpiAndroid) = $event)),
                    mode: "currency",
                    min: $setup.minAndroid,
                    currency: $setup.selectedCurrency,
                    class: _normalizeClass([ $setup.cpiAndroid< $setup.minAndroid ? 'p-invalid' : '' ])
                  }, null, 8, ["onInput", "modelValue", "min", "currency", "class"]),
                  _withDirectives(_createElementVNode("select", {
                    class: "multi-select",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.selectedCurrency) = $event)),
                    disabled: $props.campaign?.budget.currency,
                    onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.emitNewValue && $setup.emitNewValue(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currency, (cur, index) => {
                      return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(cur), 1))
                    }), 128))
                  ], 40, _hoisted_26), [
                    [_vModelSelect, $setup.selectedCurrency]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_InputNumber, {
                    onInput: $setup.emitNewValue,
                    "input-style": "background: #FFFFFF;bcountingProgressox-shadow:\n              3px 4px 15px rgba(0, 0, 0, 0.1);font-weight: bold;font-size: 24px;\n                        border-bottom-left-radius: 10px;border-top-left-radius: 10px;padding-left:25px;\n                        line-height: 29px;color: #162020;",
                    modelValue: $setup.cpiIos,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.cpiIos) = $event)),
                    mode: "currency",
                    min: $setup.minIos,
                    currency: $setup.selectedCurrency,
                    class: _normalizeClass([ $setup.cpiIos < $setup.minIos ? 'p-invalid' : '' ])
                  }, null, 8, ["onInput", "modelValue", "min", "currency", "class"]),
                  _withDirectives(_createElementVNode("select", {
                    class: "multi-select",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.selectedCurrency) = $event)),
                    disabled: $props.campaign?.budget.currency,
                    onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.emitNewValue && $setup.emitNewValue(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currency, (cur, index) => {
                      return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(cur), 1))
                    }), 128))
                  ], 40, _hoisted_30), [
                    [_vModelSelect, $setup.selectedCurrency]
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_31
        ]))
      : _createCommentVNode("", true),
    _hoisted_32,
    _createElementVNode("div", null, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_InputNumber, {
          onInput: $setup.emitNewValue,
          "input-style": "background: #FFFFFF;bcountingProgressox-shadow: 3px 4px 15px rgba(0, 0, 0, 0.1);font-weight: bold;font-size: 24px;\n                        border-bottom-left-radius: 10px;border-top-left-radius: 10px;padding-left:25px;\n                        line-height: 29px;color: #162020;",
          id: "currency-usa",
          modelValue: $setup.totalCampaignBudget,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.totalCampaignBudget) = $event)),
          mode: "currency",
          currency: $setup.selectedCurrency,
          class: _normalizeClass([ $setup.totalCampaignBudget < 1 ? 'p-invalid' : '' ])
        }, null, 8, ["onInput", "modelValue", "currency", "class"]),
        _withDirectives(_createElementVNode("select", {
          class: "multi-select",
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.selectedCurrency) = $event)),
          disabled: $props.campaign?.budget.currency,
          onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.emitNewValue && $setup.emitNewValue(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currency, (cur, index) => {
            return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(cur), 1))
          }), 128))
        ], 40, _hoisted_35), [
          [_vModelSelect, $setup.selectedCurrency]
        ])
      ]),
      ($props.paymentMethod === $setup.CampaignPaymentMethod.CPM && !$setup.isMinimalBudget)
        ? (_openBlock(), _createElementBlock("p", _hoisted_36, " The budget should not be less than the cost for 50 views based on your CPM rate. "))
        : _createCommentVNode("", true),
      ($props.paymentMethod === $setup.CampaignPaymentMethod.CPI && !$setup.isMinimalBudget)
        ? (_openBlock(), _createElementBlock("p", _hoisted_37, " The budget should not be less than the cost for 50 installations based on your CPI rate. "))
        : _createCommentVNode("", true),
      ($props.paymentMethod === $setup.CampaignPaymentMethod.CPC && !$setup.isMinimalBudget)
        ? (_openBlock(), _createElementBlock("p", _hoisted_38, " The budget should not be less than the cost for 50 clicks based on your CPC rate. "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_39, [
        _createVNode(_component_Checkbox, {
          id: "binary",
          modelValue: $setup.verifyPaymentInfo,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.verifyPaymentInfo) = $event)),
          binary: true,
          onChange: $setup.emitNewValue
        }, null, 8, ["modelValue", "onChange"]),
        _hoisted_40
      ])
    ]),
    _createVNode(_component_SecretTip, {
      class: "p-mt-6",
      text: `${$props.paymentMethod} is important for creators, if you make your ${$props.paymentMethod}
     rate too low, it may discourage creators to take part in the campaign`
    }, null, 8, ["text"])
  ]))
}